"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var range_slider_1 = require("./range-slider");
/**
 * Espilon Typography Module
 */
var EpsilonTypography = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; params: {value: number; id: string}}} control
     */
    function EpsilonTypography(control) {
        this.control = control;
        this.context = jQuery(control.container);
        this.container = this.context.find('.epsilon-typography-container');
        this.selects = this.container.find('select');
        this.inputs = this.container.find('.epsilon-typography-input');
        this.sliders = this.container.find('.slider-container');
        this.id = control.params.id;
        this.init();
    }
    /**
     * Initiator
     */
    EpsilonTypography.prototype.init = function () {
        var self = this;
        var sliderSettings;
        /**
         * Instantiate the selectize javascript plugin
         * and the input type number
         */
        try {
            this._selectize = this.selects.selectize();
        }
        catch (err) {
            /**
             * In case the selectize plugin is not loaded, raise an error
             */
            console.warn('selectize not yet loaded');
        }
        /**
         * On clicking the advanced options toggler,
         */
        this.context.on('click', '.epsilon-typography-advanced > a', function (e) {
            var toggle = jQuery(this).attr('data-toggle');
            e.preventDefault();
            jQuery(this).toggleClass('active').parent().toggleClass('active');
            jQuery('#' + toggle).slideToggle().addClass('active');
        });
        /**
         * Great use of the EpsilonFramework, ahoy!
         */
        jQuery.each(this.sliders, function (index, element) {
            var sliderType = jQuery(element).attr('data-slider-type'), sliderSettings = {
                container: element,
                params: {
                    value: 0,
                    id: '',
                    sliderControls: {
                        min: 0,
                        max: 10,
                        step: 1
                    }
                }
            };
            switch (sliderType) {
                case 'letter-spacing':
                    sliderSettings.params.value = self.control.params.inputs['letter-spacing'];
                    sliderSettings.params.id = self.control.params.id + '-letter-spacing';
                    sliderSettings.params.sliderControls.min = 0;
                    sliderSettings.params.sliderControls.max = 5;
                    sliderSettings.params.sliderControls.step = 0.1;
                    break;
                case 'line-height':
                    sliderSettings.params.value = self.control.params.inputs['line-height'];
                    sliderSettings.params.id = self.control.params.id + '-line-height';
                    sliderSettings.params.sliderControls.min = 0;
                    sliderSettings.params.sliderControls.max = 40;
                    sliderSettings.params.sliderControls.step = 1;
                    break;
                default:
                    sliderSettings.params.value = self.control.params.inputs['font-size'];
                    sliderSettings.params.id = self.control.params.id + '-font-size';
                    sliderSettings.params.sliderControls.min = 0;
                    sliderSettings.params.sliderControls.max = 40;
                    sliderSettings.params.sliderControls.step = 1;
                    break;
            }
            new range_slider_1.EpsilonRangeSlider(sliderSettings);
        });
        this.handleEvents();
    };
    /**
     * Handle Events
     */
    EpsilonTypography.prototype.handleEvents = function () {
        var self = this;
        /**
         * On triggering the change event, create a json with the values and
         * send it to the preview window
         */
        this.inputs.on('change', function () {
            var val = self._parseJson();
            jQuery('#hidden_input_' + self.id).val(val).trigger('change');
        });
    };
    /**
     * Parse/create the json and send it to the preview window
     *
     * @param inputs
     * @param id
     * @private
     */
    EpsilonTypography.prototype._parseJson = function () {
        var self = this;
        var object = {
            action: 'epsilon_generate_typography_css',
            class: 'Epsilon_Typography',
            id: this.control.id,
            data: {
                selectors: this.control.params.selectors,
                stylesheet: this.control.params.stylesheet,
                id: this.control.id,
                json: {},
            }
        }, api = wp.customize;
        jQuery.each(this.inputs, function (index, value) {
            var key = jQuery(value).attr('id'), replace = self.id + '-', type = jQuery(this).attr('type');
            key = key.replace(replace, '');
            if ('checkbox' === type) {
                object.data.json[key] = jQuery(this).prop('checked') ? jQuery(value).val() : '';
            }
            else {
                object.data.json[key] = jQuery(value).val();
            }
        });
        api.previewer.send('update-inline-typography-css', object);
        return JSON.stringify(object.data);
    };
    return EpsilonTypography;
}());
exports.EpsilonTypography = EpsilonTypography;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/typography.ts
// module id = 47
// module chunks = 0